import { ACTIVATE_CONSUMER_ENROLLMENT } from './types';

export const activateConsumerForm = (data) => async dispatch => {
    try {
        dispatch({ type: ACTIVATE_CONSUMER_ENROLLMENT, payload: data });
    } catch (errors) {
        console.log(errors)
    }
};